import React, { useState ,useEffect} from 'react';
import { Link, useNavigate } from "react-router-dom";
import DefaultBoard from './DefaultBoard';
import Profile from './Profile';
import BookAppointment from './BookAppointment';
import Notification from './Notification';
import Requirement from './Requirement';
import AddClientsForm from './AddClientForm';
function Home() {
  const [selectedMenu, setSelectedMenu] = useState('DashBoard');
  const [canAddClient, setCanAddClient] = useState(() => {
    try { return localStorage.getItem('hasAcceptedRequirement') === 'true'; } catch (e) { return false; }
  });
  const navigate = useNavigate();

  useEffect(() => {
    const storageHandler = (e) => {
      if (!e.key) return;
      if (e.key === 'hasAcceptedRequirement') {
        try { setCanAddClient(localStorage.getItem('hasAcceptedRequirement') === 'true'); } catch (err) { }
      }
    };
    window.addEventListener('storage', storageHandler);
    return () => window.removeEventListener('storage', storageHandler);
  }, []);

  const handleLogout = () => {
    // Clear localStorage or any other auth data
    localStorage.removeItem("token");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("clientEmail");
    localStorage.removeItem("userId");
    // Clear the requirement-acceptance flag as well
    try { localStorage.removeItem('hasAcceptedRequirement'); } catch (e) { }

    // Redirect to login page
    navigate("/clientlogin");
  };

  const renderContent = () => {
    switch (selectedMenu) {
      case 'Profile':
          return <Profile />;
      case 'DashBoard':
          return <DefaultBoard />;
      case 'Requirements':
        return <Requirement />;
      case 'ClientForm':
          return canAddClient ? <AddClientsForm /> : (
            <div className="p-6 bg-white rounded shadow">Add Client is locked until a quotation is accepted.</div>
          );
        case 'Appointments':
          return <BookAppointment/>;
        case 'Notifications':
          return <Notification/>;
      default:
        return <DefaultBoard />;
    }
  };

  const menuItems = [
    { key: 'Profile', icon: 'bi-speedometer2', label: 'Profile' },
    { key: 'DashBoard', icon: 'bi-speedometer2', label: 'Workspace' },
    { key: 'Requirements', icon: 'bi-list', label: 'Requirements' },
    { key: 'ClientForm', icon: 'bi-person-plus', label: 'Add Client' },
    { key: 'Notifications', icon: 'bi-bell', label: 'Notifications' },
    { key: 'Appointments', icon: 'bi-calendar', label: 'Book Appointment' },
    
  ];

  return (
    <div className="flex min-h-screen bg-gray-100"   style={{
  backgroundImage: "url('/assets/img/bg-3.jpg')",
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
}}>
     
      {/* Sidebar */}
      <aside className="w-64 bg-gray-900 text-white flex flex-col py-6 px-4 space-y-2">
        <Link to="/" className="text-sm text-gray-300 hover:text-white mb-4">
          Home / DashBoard
        </Link>
        <hr className="border-gray-700" />

        <ul className="space-y-2 mt-4">
          {menuItems.map((item) => (
            <li
              key={item.key}
              onClick={() => {
                if (item.key === 'ClientForm' && !canAddClient) {
                  alert('Add Client is locked until a quotation is accepted.');
                  return;
                }
                setSelectedMenu(item.key);
              }}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg ${item.key === 'ClientForm' && !canAddClient ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} transition-colors duration-200 
                ${selectedMenu === item.key ? 'bg-green-600 text-white' : 'hover:bg-gray-700 text-gray-300'}`}
            >
              <i className={`bi ${item.icon} text-lg`}></i>
              <span className="text-base">{item.label}{item.key === 'ClientForm' && !canAddClient ? ' (locked)' : ''}</span>
            </li>
          ))}
          <hr className="border-gray-700" />
             <button
        onClick={handleLogout}
        className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
      >
        Logout
      </button>
        </ul>
      </aside>

      {/* Content Area */}
      <main className="flex-1 p-6">
        {renderContent()}
      </main>
    </div>
  );
}

export default Home;
